import { render } from "./PC_Main.vue?vue&type=template&id=fa9a3058"
import script from "./PC_Main.vue?vue&type=script&lang=js"
export * from "./PC_Main.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\back\\new\\sever\\src\\frontend\\22\\userweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__